import React, { useState } from 'react'
import { getTravelersChart } from 'src/services/api/charts'
import { Chart } from '../components/chart'
import { Props } from './types'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    type: 'pie'
  },
  title: {
    text: 'Despesas de Viagens'
  },
  tooltip: {
    valueSuffix: ''
  },
  subtitle: {
    text: ''
  },
  plotOptions: {
    series: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: [
        {
          enabled: true,
          distance: 20
        },
        {
          enabled: true,
          distance: -40,
          format: 'R$: {point.percentage:.2f}',
          style: {
            fontSize: '1.2em',
            textOutline: 'none',
            opacity: 0.7
          },
          filter: {
            operator: '>',
            property: 'Percentual',
            value: 10
          }
        }
      ]
    }
  },
  series: [
    {
      name: 'Despesas R$',
      colorByPoint: true,
      data: [] as any
    }
  ]
}

function updateChatData(data: []) {
  return {
    ...chartData,
    series: [{ name: 'Despesas R$', colorByPoint: true, data }]
  }
}

export default function Travelers({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getTravelersChart(
      organization_id,
      monthFilter,
      date_end
    )

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData([])
    }

    return updateChatData(response.data.data)
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
